// This component used in `Layout.tsx`, do not remove this file
export const NotFound = () => null;
